import { Button, Tooltip } from "antd";
import { useContext } from "react";
import { useForm } from "antd/lib/form/Form";
import { OverlayContext } from "../context/OverlayContext";
import { ToastContext } from "../context/ToastContext";
import { WalletForm } from "../pages/admin/accounts/WalletForm";
import { formatPriceInCents } from "../utils/common";

export const WalletFormButton = ({
    userId = null,
    actorAccountId = null,
    actorBookingsExternalId = null,
    buttonLabel = "Wallet",
    title = "Wallet",
    onBalanceChange = (balanceCents) => {},
  }) => {
  const [form] = useForm<{ id: string | number; balance: number }>();
  const { loading } = useContext(ToastContext);
  const { openModal, closeModal } = useContext(OverlayContext);

  const openBalanceModal = () => {
    form.resetFields();
    openModal({
      title,
      okText: "Close",
      hasCancel: false,
      content: <WalletForm
        form={form}
        actorAccountId={actorAccountId}
        actorBookingsExternalId={actorBookingsExternalId}
        userId={userId}
        onBalanceUpdate={(balance) => {
          onBalanceChange(balance);
          closeModal();
          openModal({
            title: 'Wallet balance changed',
            content: (<p>New balance: {formatPriceInCents(balance, null)}</p>),
            okText: 'Close',
            hasCancel: false,
          })
        }}
      ></WalletForm>,
      onOk: () => {
        closeModal();
      },
    });
  };

  return (
    <Button disabled={loading} type="primary" onClick={openBalanceModal}>
      { buttonLabel }
    </Button>
  );
};

